import createCardListingView from '../Views/createCardListingView';
import FlexRobotCard from './FlexRobotCard';

export default createCardListingView(FlexRobotCard, {
  displayName: 'RobotListingView',
});
